<div class="modal-content">
    <div class="modal-header">
      <div>
        <h4>O‘qituvchi bandligini tekshirish</h4>
      </div>
      <div>
        <button type="button" class="btn btn-outline-danger" (click)="close()">Bekor qilish</button>
      </div>
    </div>
    <div class="modal-body" [class.found]="calendarVisible">
      <div id="eventTooltip" style="display: none; position: absolute; background-color: #fff; padding: 5px; border: 1px solid #ccc;"></div>
      <div class="modal-body_item mtop10" >
          <label>O‘qituvchi</label>
          <div class="modal-body_item_sec">
              <div class="modal-body_item_sec">
                  <ng-autocomplete
                      [data]="timeTableTeachers"
                      class="form-control-inner"
                      [searchKeyword]="keyword"
                      (selected)='selectTeacherEvent($event)'
                      (inputCleared) = 'teacherClearedEvent($event)'
                      [itemTemplate]="itemTemplate"
                      id="teacher_yu"
                      #teacher_yu
                  >
                  </ng-autocomplete>
                <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.name"></a>
                </ng-template>
      
                <ng-template #notFoundTemplateRoom let-notFound>
                     <div class="red">
                      topilmadi! 
                   </div>
                </ng-template>
              </div>
          </div>      
      </div> 
      <div *ngIf="queue"><h5>Tanlangan o‘qituvchi navbati: <strong style="font-size: 20px;">{{queue}}</strong>, Web sahifa ochiq turishi shart emas, navabtingiz kelsa o'zi ma'lumotlarni yangilab qo‘yadi</h5></div>
      <div *ngIf="timer$ | async"><h5>Kiyingi iqtiboslik olingunicha <strong style="font-size: 20px;">{{((timer$ | async)-(timer$ | async)%60)/60}}:{{(timer$ | async)%60}}</strong></h5></div>
      <div *ngIf="error"><h5 style="color: red;">So'rovlar ko'p, kiyinroq urinib ko‘ring!!!</h5></div>
      <div class="table-responsive">
        <ng2-smart-table 
            id="excelTable" 
            [settings]="settings" 
            [source]="dataSource"
        ></ng2-smart-table>
      </div>
    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger" (click)="close()">Bekor qilish</button>
    </div> -->
</div>